import logger from './logger';
import {isAccessTokenExpiringWithin, refreshAccessToken} from './authRuntime';

export const WAKE_REFRESH_WINDOW_SECONDS = 30;
export const WAKE_REFRESH_THROTTLE_MS = 10_000;

let installed = false;

export const installWakeTokenRefresh = (): (() => void) => {
    if (installed || typeof window === 'undefined') {
        return () => undefined;
    }
    installed = true;
    let lastAttemptAt = Number.NEGATIVE_INFINITY;

    const refreshIfNearExpiry = (trigger: string) => {
        if (!isAccessTokenExpiringWithin(WAKE_REFRESH_WINDOW_SECONDS)) {
            return;
        }
        const now = Date.now();
        if (now - lastAttemptAt < WAKE_REFRESH_THROTTLE_MS) {
            return;
        }
        lastAttemptAt = now;
        refreshAccessToken().catch((error) => {
            logger.warn('Proactive token refresh failed', {
                source: 'auth',
                event: 'wake_token_refresh_failed',
                trigger,
                error: error instanceof Error ? error.message : String(error),
            });
        });
    };

    const onVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            refreshIfNearExpiry('visibilitychange');
        }
    };
    const onPageShow = () => refreshIfNearExpiry('pageshow');
    const onOnline = () => refreshIfNearExpiry('online');

    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('pageshow', onPageShow);
    window.addEventListener('online', onOnline);

    return () => {
        document.removeEventListener('visibilitychange', onVisibilityChange);
        window.removeEventListener('pageshow', onPageShow);
        window.removeEventListener('online', onOnline);
        installed = false;
    };
};
